import { themeVar } from './themeConfig';

export const themedAvatarRule = {
  backgroundImage: themeVar('shell', 'avatarBackground', 'none'),
};
